module.exports = __webpack_public_path__ + "img/black_board_title.e9efef38.png";